// Chip-style filters for the Inbox. Inspired by Mochi's tag-routing UI
// but applied to our draft+lead state model.

interface Props {
  active: FilterKey;
  onChange: (k: FilterKey) => void;
  counts: Record<FilterKey, number>;
}

export type FilterKey = "pending" | "qualified" | "booked" | "all";

const FILTERS: Array<{ key: FilterKey; label: string; emoji: string }> = [
  { key: "pending", label: "Pending", emoji: "⏳" },
  { key: "qualified", label: "Qualifiés", emoji: "🔥" },
  { key: "booked", label: "Bookés", emoji: "📅" },
  { key: "all", label: "Tous", emoji: "·" },
];

export function InboxFilters({ active, onChange, counts }: Props) {
  return (
    <div className="flex items-center gap-1.5">
      {FILTERS.map((f) => (
        <button
          key={f.key}
          onClick={() => onChange(f.key)}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
            active === f.key
              ? "bg-accent-500 text-white shadow-glow"
              : "bg-bg-elevated text-text-muted hover:bg-bg-hover hover:text-text"
          }`}
        >
          <span className="text-[10px]">{f.emoji}</span>
          {f.label}
          <span
            className={`tabular-nums ${
              active === f.key ? "text-white/80" : "text-text-dim"
            }`}
          >
            {counts[f.key] ?? 0}
          </span>
        </button>
      ))}
    </div>
  );
}
